export default "__VITE_ASSET__DmBqm$3M__"